const ALERT_MESSAGE = {
    EMAIL_NOT_EXIST:
        "A valid email address must exist to export as email.  Please update the client profile.",
    MOBILE_NOT_EXIST:
        "A valid mobile number must exist to export as SMS.  Please update the client profile.",
    EXTENSION_SMS_DISABLED:
        "Enable SMS Messaging add on to utilize this feature. Please contact the administrator to enable the feature at Settings > Add On > One/Two-Way SMS."
};

const CONTACT_DETAIL_TYPES = {
    ALL: 0,
    EMAIL: 1,
    MOBILE: 2,
    HOME: 3,
    WORK: 4,
    FAX: 5
};

const CONTACT_DETAIL_TYPE_LIST = {
    [CONTACT_DETAIL_TYPES.ALL]: {
        ID: CONTACT_DETAIL_TYPES.ALL,
        LABEL: "All"
    },
    [CONTACT_DETAIL_TYPES.EMAIL]: {
        ID: CONTACT_DETAIL_TYPES.EMAIL,
        LABEL: "Email"
    },
    [CONTACT_DETAIL_TYPES.MOBILE]: {
        ID: CONTACT_DETAIL_TYPES.MOBILE,
        LABEL: "Mobile"
    },
    [CONTACT_DETAIL_TYPES.HOME]: {
        ID: CONTACT_DETAIL_TYPES.HOME,
        LABEL: "Home"
    },
    [CONTACT_DETAIL_TYPES.WORK]: {
        ID: CONTACT_DETAIL_TYPES.WORK,
        LABEL: "Work"
    },
    [CONTACT_DETAIL_TYPES.FAX]: {
        ID: CONTACT_DETAIL_TYPES.FAX,
        LABEL: "Fax"
    }
};

export default {
    ALERT_MESSAGE,
    CONTACT_DETAIL_TYPES,
    CONTACT_DETAIL_TYPE_LIST
};
